import { useRecoverPasswordDoneMutation } from "../../hooks/mutations/auth/useRecoverPasswordDoneMutation"

import { RecoverPasswordDoneForm } from "./RecoverPasswordDoneForm.form"

export const RecoverPasswordDoneFormPost = (props: RecoverPasswordDoneFormPostProps) => {
    const {
        token,
        className,
        onSuccess,
    } = props

    const recoverPassword = useRecoverPasswordDoneMutation({
        onSuccess,
    })

    const handleSubmit = async (_values) => {
        await recoverPassword.mutateAsync(_values)
    }

    return (
        <RecoverPasswordDoneForm
            initialValues={{
                token,
                password: "",
                confirmPassword: "",
            }}
            className={className}
            onSubmit={handleSubmit}
        />
    )
}

type RecoverPasswordDoneFormPostProps = {
    className: string,
    onSuccess: () => void,
    token: string,
}

